import type { Collaborators } from '@/types/github';

export const collaboratorsQueryKey = (owner: string, repo: string) =>
  ['collaborators', owner, repo] as const;

export async function fetchCollaborators(
  owner: string | undefined,
  repo: string | undefined,
  signal?: AbortSignal,
  requireComplete = false,
): Promise<Collaborators | null> {
  if (!owner || !repo) {
    return null;
  }

  const collaborators: Collaborators = [];
  for (let page = 1; ; page++) {
    const suffix = requireComplete ? `?per_page=100&page=${page}` : '';
    const response = await fetch(`/api/github/repos/${owner}/${repo}/collaborators${suffix}`, {
      method: 'POST',
      signal,
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch collaborators: ${response.statusText}`);
    }
    const batch: Collaborators = await response.json();
    collaborators.push(...batch);
    if (!requireComplete || batch.length < 100) {
      return collaborators;
    }
  }
}
